import styled from 'styled-components';

export const Image = styled.img`
  width: 100%;
  filter: sepia(0%) saturate(100%) brightness(95%) hue-rotate(0deg);
`;
